import { AccountModel } from '../account';

export class BackupModel {
  id: string;
  accountId: string;
  ultimo: string;
  tamanho: number;
  pendentes: number;
  efetuados: number;
  schedule: string;
  created: Date;
  updated: Date;
  running: boolean;
  account: AccountModel;

  constructor(data?: Partial<BackupModel>) {
    Object.assign(this, data);
  }
}

export interface BackupFile {
  key: string;
  fileName: string;
  size: number;
  lastModified: Date;
}

export interface BackupDownloadUrl {
  url: string;
  expiresIn: number;
  fileName: string;
}
